import { ErrorIcon, InProgressIcon } from '@assets/icons';
import { IconButton } from '@components/button';
import { Tooltip } from '@components/tooltip';
import { Box } from '@mui/material';

interface DatasetStatusIconProps {
  status: string;
  organizationId: string;
  workspaceId: string;
  datasetId: string;
}

export const DatasetStatusIcon = ({
  status,
  organizationId,
  workspaceId,
  datasetId,
}: DatasetStatusIconProps) => {
  const lowerStatus = (status || '').toLocaleLowerCase();

  const url = `/${organizationId}/workspaces/${workspaceId}/datasets/${datasetId}/logs`;

  if (lowerStatus === 'failed' || lowerStatus === 'cancelled') {
    return (
      <Tooltip title="View logs" variant="secondary" disableInteractive>
        <IconButton
          Icon={ErrorIcon}
          variant="error"
          size={16}
          onClick={(e) => {
            e.preventDefault();
            window.open(url, '_blank');
          }}
          style={{ cursor: 'pointer' }}
        />
      </Tooltip>
    );
  }
  if (
    lowerStatus !== 'success' &&
    lowerStatus !== 'completed' &&
    lowerStatus !== 'complete' &&
    lowerStatus !== 'failed' &&
    lowerStatus !== 'cancelled'
  ) {
    return (
      <Box sx={{ px: '6px', pt: '6px', pb: '1px' }}>
        <InProgressIcon size={16} />
      </Box>
    );
  }
  return null;
};
